import $http from "@/plugins/axios.js";
import router from "@/router";

// const decodToken = (token) => {
//   try {
//     const base64Url = token.split(".")[1];
//     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split("")
//         .map(function (c) {
//           return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
//         })
//         .join("")
//     );
//     return JSON.parse(jsonPayload);
//   } catch (e) {
//     throw new Error("Token is not valid!");
//   }
// };

export default {
  state: {
    userInfo: {},
    authError: "",
    me: {},
    userPermisstions:
      JSON.parse(localStorage.getItem("sar-permisstions")) || [],
    userPermissions: new Set(),
  },
  getters: {
    userInfo: (state) => state.userInfo,
    me: (state) => state.me,
    userPermissions: (state) => state.userPermissions,
  },
  actions: {
    async getMe({ commit }) {
      const request = await $http.get("/auth");
      commit("SET_ME", request.data);
      return request.data;
    },

    async login({ commit }, data) {
      try {
        const res = await $http.post("/auth/login", data);
        localStorage.setItem(
          "token",
          JSON.stringify(res.data.data.accessToken)
        );
        localStorage.setItem("user", JSON.stringify(res.data.data.user));
        if (router.currentRoute.query.redirect) {
          router.push(router.currentRoute.query.redirect);
        } else {
          router.push("/cards");
        }
        commit("SET_AUTH_ERROR", "");
        commit("SET_USER", res.data);
      } catch (e) {
        if (
          e.response.status === 404 ||
          e.response.status === 500 ||
          e.response.status === 400
        ) {
          commit("SET_AUTH_ERROR", e.response.data.message);
        } else if (e.response.status === 403) {
          commit("SET_AUTH_ERROR", e.response.data.message);
        }
      }
    },

    async updateUsersPassword({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/auth/changePassword", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
      }
    },

    updateUserPermissions({ commit }, payload) {
      commit("SET_USER_PERMISSIONS", payload);
    },

    async logout({ commit }) {
      try {
        // await $http.post("/auth/logout");
        localStorage.removeItem("token");
        localStorage.removeItem("user_info");
        localStorage.removeItem("permissions");
        router.push({ name: "login" });
        return commit;
      } catch (e) {
        console.log(e);
      }
    },
  },
  mutations: {
    SET_USER(state, data) {
      state.userInfo = data.user;
    },
    SET_ME(state, data) {
      state.me = data;
    },
    SET_USER_PERMISSIONS(state, data) {
      state.userPermissions = new Set();
      data.forEach((p) => {
        state.userPermissions.add(p.key);
      });
    },
    SET_AUTH_ERROR(state, error) {
      state.authError = error;
    },
  },
};
